import { PRODUCT_REQUISITION_TIME } from "@component/Mortgage/LeadForm/Steps/LeadForm.data";
import { MAX_LOAN_AMOUNT, MIN_LOAN_AMOUNT } from "@component/PersonalLoan/Calculator/data";
import type { LeadFormProps, LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { faClock as fasClock } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import autobind from "autobind-decorator";
import { FormCurrency, FormDecidable, FormSelect } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";

export interface PersonalLoanLeadStepFields extends LeadFormStepFields {
	loanAmount: boolean;
	wantsWithOnlineService?: boolean;
	inKHR?: boolean;
}

export interface PersonalLoanLeadProps extends LeadFormProps {
	showDetails?: boolean;
	withInKhr?: boolean;
	loanAmount?: number;
	maturityYears?: number;
	installment?: number;
	apr?: number;
}

export class LeadForm<
	StepFields extends PersonalLoanLeadStepFields = PersonalLoanLeadStepFields,
	Props extends PersonalLoanLeadProps = PersonalLoanLeadProps,
> extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: "Kérj ingyenes visszahívást személyi hitel szakértőnktől!",
		button: "Tájékoztatást kérek",
	};

	protected renderFields(): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormSelect
					name="productRequisitionTime"
					prepend={<FontAwesomeIcon icon={fasClock} />}
					options={PRODUCT_REQUISITION_TIME}
					placeholder="Mikor van szükséged a hitelre?"
					disabled={submitState !== undefined}
					required
				/>
				<FormCurrency
					name="loanAmount"
					placeholder="Hitelösszeg"
					validate={this.validateLoanAmount}
					disabled={submitState !== undefined}
					required
				/>
				<FormDecidable
					name="wantsWithOnlineService"
					label="Online szeretnéd megkötni?"
					disabled={submitState !== undefined}
					required
				/>
			</>
		);
	}

	@autobind
	private validateLoanAmount(loanAmount: number): string {
		if (isNaN(loanAmount)) {
			return "A hitelösszeg megadása kötelező!";
		}

		if (loanAmount < MIN_LOAN_AMOUNT) {
			return `A minimálisan felvehető hitelösszeg ${formatText(MIN_LOAN_AMOUNT, "ft")}!`;
		}

		if (loanAmount > MAX_LOAN_AMOUNT) {
			return `A maximálisan felvehető hitelösszeg ${formatText(MAX_LOAN_AMOUNT, "ft")}!`;
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
